@file:Suppress("UnsafeCastFromDynamic")
package chat

/** Aggregate interaction counts. No identity, cat details or browser history leave the client. */
internal object Analytics {
    private val window: dynamic = js("window")
    private const val COUNT_KEY = "nouveau-chat.analytics.session-count.v1"
    private var sessionCount = 0
    private var restored = false

    private fun enabled(): Boolean {
        val config = window.nouveauChatAnalytics ?: return false
        val hosts: dynamic = config.hosts
        return config.enabled == true && hosts != null && hosts.includes(window.location.hostname) == true &&
            window.navigator.doNotTrack != "1" && window.doNotTrack != "1" &&
            window.navigator.globalPrivacyControl != true
    }

    fun catDisplayed() {
        if (!enabled()) return
        if (!restored) {
            restored = true
            try {
                sessionCount = (window.sessionStorage.getItem(COUNT_KEY) as String?)
                    ?.toIntOrNull()?.coerceIn(0, 2) ?: 0
            } catch (_: Throwable) { /* In-memory counting remains available. */ }
        }
        if (sessionCount >= 2) return
        sessionCount++
        try { window.sessionStorage.setItem(COUNT_KEY, sessionCount.toString()) } catch (_: Throwable) { }
        send(if (sessionCount == 1) "first_cat_displayed" else "second_cat_displayed", "none")
    }

    fun loadFailed(reason: String) {
        if (enabled()) send("cat_load_failed", reason)
    }

    private fun send(event: String, reason: String) {
        try {
            val payload = js("({})")
            payload.event = event
            payload.reason = reason
            val options = js("({})")
            options.method = "POST"
            options.headers = js("({'Content-Type':'application/json'})")
            options.credentials = "omit"
            options.keepalive = true
            options.body = JSON.stringify(payload)
            val controller = js("new AbortController()")
            options.signal = controller.signal
            val timer = window.setTimeout({ controller.abort() }, 3000)
            // Best effort: no retries, no UI error, no blocking of the cat request.
            window.fetch("/api/events", options).then({ _: dynamic -> window.clearTimeout(timer) })
                .catch { _: dynamic -> window.clearTimeout(timer) }
        } catch (_: Throwable) { /* Analytics must never break the experience. */ }
    }
}
